import Slider from 'react-slick';
import React, { useCallback, useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import toHref, { getTestimonial } from '../tools/fetcher';

export default function TestimonialSlider() {
    const [testimonials, setTestimonials] = useState([]);

    const pathImg = (imgName) =>
        toHref(
            `/wp-content/plugins/react-plugin/react-app/build/assets/dummy/${imgName}.svg`,
        );

    const Slide = useCallback(
        ({ testy }) =>
            testy ? (
                <div className={'bg-white max-w-[360px] mr-4 rounded-[20px] p-[5px] sm:mr-10'}>
                    <div className={'bg-primary-white-101 p-8 rounded-[16px]'}>
                        <img  src={pathImg('quotation')} alt={'Quotation Mark'}/>
                        <p className={'mt-[14px] text-primary-gray-101 text-base '}>
                            {testy?.description}
                        </p>
                    </div>
                    <div className={'px-[19px] py-[28px]'}>
                        <div className={'flex items-center gap-6'}>
                            {testy?.imageSrc && (
                                <img
                                    src={testy.imageSrc}
                                    alt={testy?.imageAlt || testy?.name}
                                    className={
                                        'h-[48px] w-[48px] object-contain rounded-full'
                                    }
                                />
                            )}
                            <div>
                                <h1
                                    className={
                                        'font-bold leading-7 text-base'
                                    }
                                >
                                    {testy?.name}
                                </h1>
                                <p className={'leading-7 text-base text-primary-gray-101'}>
                                    {testy?.address}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>NOT FOUND</div>
            ),
        [],
    );
    const settings = {
        autoplay: true,
        autoplaySpeed: 10000,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: false,
        // adaptiveHeight: true,
        swipeToSlide: true,
        // prevArrow: '<span class="slickArrow slickArrow--prev"></span>',
        // nextArrow: '<span class="slickArrow slickArrow--next"></span>',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    centerMode: true,
                    centerPadding: '24px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '24px',
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        getTestimonial().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    name: d?.title?.rendered,
                    address: d?.testimonial_details?.address,
                    imageSrc: d?.testimonial_details?.image_src,
                    imageAlt: d?.testimonial_details?.image_alt,
                    description: d?.testimonial_details?.description,
                }));
                setTestimonials(dt);
            }
        });
    }, []);

    return (
        <div className={'sm:col-span-2 overflow-hidden relative'}>
            <div className="w-[calc(100%+32px)] sm:w-[calc(100%+40px)] -ml-2 sm:ml-0">
                {testimonials.length > 0 && (
                    testimonials.length === 1 ? (
                        <div className={'flex items-center justify-start px-6'}>
                            <Slide key={0} testy={testimonials[0]} />
                        </div>
                    ) : (
                        <Slider {...settings}>
                            {testimonials.map((testy, index) => (
                                <Slide key={index} testy={testy} />
                            ))}
                        </Slider>
                    )
                )}
            </div>
        </div>
    );
}
